// Tunnel d'achat : panier (Cart.jsx) et checkout (Checkout.jsx).
// RÈGLE : les valeurs françaises sont le texte EXACT du site d'avant la
// traduction — on ne réécrit pas la copie en passant.
export default {
  // --- Panier (Cart.jsx) ---
  'tunnel.panier.seoTitre': 'Mon Panier',
  'tunnel.panier.seoDescription':
    'Consultez votre panier Joyful Reveal et procédez au paiement sécurisé Stripe. Réappliquez une promo code si vous en avez un.',
  'tunnel.panier.titre': '🛒 Ton Panier',
  'tunnel.panier.sousTitreVide':
    'Commence une aventure en collectant les pièces du puzzle',
  'tunnel.panier.sousTitreUn': 'Tu as {n} pièce dans ton panier',
  'tunnel.panier.sousTitrePlusieurs': 'Tu as {n} pièces dans ton panier',
  'tunnel.panier.retireTitreUn': 'Un article a été retiré de votre panier',
  'tunnel.panier.retireTitrePlusieurs':
    'Des articles ont été retirés de votre panier',
  'tunnel.panier.retireDetail':
    '{noms} — ce pack n’est plus proposé. Retrouvez nos packs actuels sur la',
  'tunnel.panier.retireDetailLien': 'boutique',
  'tunnel.panier.progression': 'Collection en Cours',
  'tunnel.panier.videTitre': 'Panier Vide',
  'tunnel.panier.videTexte':
    "Il n'y a rien ici... encore ! Commence ton aventure en collectant les pièces du puzzle.",
  'tunnel.panier.videCta': "🎯 Retourner à l'Aventure",
  'tunnel.panier.langue': 'Langue :',
  'tunnel.panier.retirerDuPanier': 'Retirer du panier',
  'tunnel.panier.sousTotal': 'Sous-total',
  'tunnel.panier.reduction': 'Réduction ({code})',
  'tunnel.panier.retirer': 'Retirer',
  'tunnel.panier.livraison': 'Livraison',
  'tunnel.panier.livraisonADeterminer': 'À déterminer',
  'tunnel.panier.codePromo': 'Code Promo',
  'tunnel.panier.appliquer': 'Appliquer',
  'tunnel.panier.promoAppliquee': 'Code "{code}" appliqué !',
  'tunnel.panier.total': 'Total',
  'tunnel.panier.offreSpeciale':
    'Collection spéciale déverrouillée! Tu es proche du grand secret.',
  'tunnel.panier.continuerCollecter': '← Continuer à Collecter',
  'tunnel.panier.procederPaiement': '🎯 Procéder au Paiement',

  // --- Checkout (Checkout.jsx) ---
  'tunnel.checkout.seoTitre': 'Paiement - Checkout Sécurisé',
  'tunnel.checkout.seoDescription':
    'Finalisez votre achat de puzzle Joyful Reveal en toute sécurité avec Stripe. Livraison rapide en France et Europe.',
  'tunnel.checkout.chargement': 'Chargement...',
  'tunnel.checkout.erreur': '❌ Erreur: {message}',
  'tunnel.checkout.etape': 'Étape {n} / 3',
  'tunnel.checkout.sansCompte':
    '✅ Pas besoin de créer un compte — votre e-mail suffit pour recevoir la confirmation et le suivi du colis.',
  'tunnel.checkout.dejaCompte': 'Vous avez déjà un compte ?',
  'tunnel.checkout.dejaCompteLien': 'Connectez-vous',
  'tunnel.checkout.dejaCompteFin': 'pour retrouver vos commandes.',
  'tunnel.checkout.etape1Titre': '📍 Adresse de Livraison',
  'tunnel.checkout.champNomComplet': 'Nom complet',
  'tunnel.checkout.champEmail': 'Email',
  'tunnel.checkout.champAdresse': 'Adresse',
  'tunnel.checkout.champVille': 'Ville',
  'tunnel.checkout.champCodePostal': 'Code Postal',
  'tunnel.checkout.choisirPays': 'Choisir un pays',
  'tunnel.checkout.paysFR': 'France',
  'tunnel.checkout.paysBE': 'Belgique',
  'tunnel.checkout.paysLU': 'Luxembourg',
  'tunnel.checkout.paysDE': 'Allemagne',
  'tunnel.checkout.paysES': 'Espagne',
  'tunnel.checkout.paysIT': 'Italie',
  'tunnel.checkout.paysNL': 'Pays-Bas',
  'tunnel.checkout.paysPT': 'Portugal',
  'tunnel.checkout.etape2Titre': '🚚 Méthode de Livraison',
  'tunnel.checkout.calculTarifs': 'Calcul des tarifs...',
  'tunnel.checkout.etapeSuivanteRequise': 'Étape suivante requise',
  'tunnel.checkout.choisirPointRelaisTexte':
    'Sélectionnez le point relais où vous souhaitez récupérer votre commande',
  'tunnel.checkout.choisirPointRelaisBouton':
    '🗺️ CLIQUEZ ICI POUR CHOISIR VOTRE POINT RELAIS',
  'tunnel.checkout.pointRelaisSelectionne': '✓ Point relais sélectionné',
  'tunnel.checkout.modifier': 'Modifier',
  // Le sélecteur de points relais est un script tiers : il peut manquer à
  // l'appel (réseau, bloqueur de publicité). Ces messages remplacent des
  // alert() en anglais.
  'tunnel.checkout.selecteurIndisponible':
    "La carte des points relais n'a pas pu se charger. Rechargez la page, et si cela persiste, désactivez votre bloqueur de publicité le temps de la commande.",
  'tunnel.checkout.choisirTransporteurDabord':
    "Choisissez d'abord un mode de livraison ci-dessus.",
  'tunnel.checkout.selecteurErreur':
    "La carte des points relais n'a pas répondu. Réessayez dans un instant.",
  // Mode de livraison affiché sur chaque option : Sendcloud en renvoie une
  // dizaine, et le nom du produit ne dit pas où le colis arrive.
  'tunnel.checkout.modePointRelais': '📍 Point relais',
  'tunnel.checkout.modeDomicile': '🏠 À domicile',
  // Ne s'affiche que si la participation est réelle. Formulation sobre : on
  // annonce ce qu'on fait, sans s'excuser du prix ni le souligner.
  'tunnel.checkout.participation': '💚 Nous prenons {montant} € à notre charge sur ce trajet',
  // Vraie parce que le tarif vient du transporteur, au centime près : aucune
  // marge n'est ajoutée dessus. Se dit sur tous les pays, sans en désigner un.
  'tunnel.checkout.portSansMarge':
    'Le tarif affiché est celui du transporteur, au centime près — nous n’ajoutons rien dessus.',
  'tunnel.checkout.livraisonDomicileTexte':
    '✓ Livré directement à votre adresse : {adresse}',
  'tunnel.checkout.indispoTitre':
    '⏳ Livraison temporairement indisponible vers ce pays',
  'tunnel.checkout.indispoTexte':
    "Aucun transporteur ne nous propose ce trajet pour le moment. Nous travaillons à l'ouvrir — en attendant, vous pouvez vérifier l'adresse saisie (code postal et ville), choisir un autre pays de livraison, ou nous écrire : nous trouverons une solution ensemble.",
  'tunnel.checkout.indispoModifierAdresse': "← Modifier l'adresse",
  'tunnel.checkout.indispoContact': '💬 Nous contacter',
  // Échec de l'appel des tarifs, à ne pas confondre avec « aucun transporteur ».
  // Les deux partageaient le même message et un incident réseau accusait donc
  // le pays de l'acheteur d'être hors zone.
  // La liste complète de Sendcloud compte jusqu'à vingt-cinq lignes, dont
  // quatre « UPS Standard » au même prix. On n'en montre que deux — un point
  // relais, un domicile — et le compteur dit combien restent en dessous.
  'tunnel.checkout.voirPlusOptions': '↓ Voir les {n} autres transporteurs',
  'tunnel.checkout.voirMoinsOptions': '↑ Afficher moins d’options',
  // Affiches pendant l'attente : un ecran fige se lit comme une panne, et
  // l'acheteur s'en va. La reprise est automatique, on le dit.
  // Barre de progression du tunnel (GameProgress). Ces deux phrases etaient
  // ecrites en dur dans le composant : un acheteur neerlandais les lisait en
  // francais juste avant de payer.
  'progression.complete': '✨ RÉVÉLATION COMPLÈTE ! ✨',
  'progression.restant': 'Plus que {n} pièces à découvrir',
  // Le tunnel de commande compte des ÉTAPES : y afficher « Plus que 23
  // pièces à découvrir » juste au-dessus du bouton de paiement inquiétait
  // l'acheteur au lieu de le rassurer.
  'progression.etapeRestante': "Plus que {n} étape avant le paiement",
  'progression.etapesRestantes': "Plus que {n} étapes avant le paiement",
  'progression.pretAPayer': "Dernière étape : le paiement",
  'tunnel.panier.etape': "Votre panier",
  'tunnel.checkout.tarifsAttenteLongue':
    "Un instant, la connexion au transporteur prend un peu plus longtemps que d'habitude.",
  'tunnel.checkout.tarifsReprise':
    'Le transporteur ne répond pas, nous réessayons ({n}/{total})…',
  'tunnel.checkout.tarifsErreurTitre':
    '⚠️ Impossible de calculer les frais de port',
  'tunnel.checkout.tarifsErreurTexte':
    "Nous avons réessayé trois fois sans succès. Ce n'est pas votre pays qui est en cause, mais notre liaison avec le transporteur. Relancez le calcul — si cela persiste, écrivez-nous et nous finaliserons la commande avec vous.",
  'tunnel.checkout.tarifsReessayer': '↻ Réessayer',
  'tunnel.checkout.etape3Titre': '💳 Paiement',
  'tunnel.checkout.redirectionStripe':
    'Vous allez être redirigé vers une page de paiement sécurisée Stripe.',
  'tunnel.checkout.redirection': 'Redirection...',
  'tunnel.checkout.procederPaiement': 'Procéder au paiement sécurisé →',
  'tunnel.checkout.retour': '← Retour',
  'tunnel.checkout.continuer': 'Continuer →',
  'tunnel.checkout.recapitulatif': '📦 Récapitulatif',
  'tunnel.checkout.recapLivraison': '🚚 Livraison ({nom})',
  'tunnel.checkout.recapReduction': '🏷️ Réduction ({code})',
  'tunnel.checkout.total': 'Total:',
  'tunnel.checkout.paiementReussi': 'Paiement Réussi!',
};
